/** Where a site stands, as a colour. The same status tokens the dashboard's
 * bars and map markers resolve (tool.css), so a status reads one colour on
 * every screen: waiting is grey, an assessment done is blue, work under way is
 * amber, a replacement is red, anything finished is green. */
const STATUS_TONE: Record<string, string> = {
  assessment_pending: "var(--ink-3)",
  assessment_in_progress: "var(--ink-3)",
  assessment_completed: "var(--accent)",
  service_overhaul: "var(--warn)",
  service_completed: "var(--ok)",
  replacement: "var(--crit)",
  replacement_completed: "var(--ok)",
  completed: "var(--ok)",
};

export function statusTone(status: string): string {
  return STATUS_TONE[status] ?? "var(--ink-3)";
}

/** A flag's code as a chip reads it: `NO_LOCATION` -> "no location". */
export function flagLabel(code: string): string {
  return code.replace(/_/g, " ").toLowerCase();
}
